jQuery(function() {
    
    // check field input validity based on hubspot
    function checkHbsptInputValidity(input, parent) {

        if(parent.find('.hs-error-msgs').length > 0){
            parent.removeClass('input-success');
            parent.addClass('input-error');
        }else{
            parent.removeClass('input-error');
            parent.addClass('input-success');
        }
    }

    //checking hubspot is ready
    window.addEventListener('message', event => {
        if(event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady') {
            
            $('.hbspt-form input[type="text"],.hbspt-form input[type="email"],.hbspt-form input[type="phone"],.hbspt-form textarea,.hbspt-form input[type="number"]').each(function(){
                var input = $(this);
                var inputId = $(this).attr('id');
                var parent = input.closest('.hs-fieldtype-text,.hs-fieldtype-textarea,.hs-fieldtype-date,.hs-fieldtype-number');
                var label = '';
                var placeHolder = '';
            
                // if there is no id setted up
                if(inputId == null){
                    inputId = input.attr('name');
                }
            
                input.on('keyup',function(){
                    if( input.val().length > 0 ){
                        parent.addClass('active');
                        setTimeout(function(){
                            checkHbsptInputValidity(input,parent);
                        },500)
                        
                    }else{
                        setTimeout(function(){
                            parent.removeClass('input-success');
                        },500)

                       
                        if(input.is('not:focus')){
                            parent.removeClass('input-success');
                            parent.removeClass('active')
                        }   
                    }
                })
            
                // on focus 
                input.on('focus',function(){
                    parent.addClass('active');
                })
            
                // on blur
                input.on('blur',function(){
                    if(input.val().length <= 0){
                        parent.removeClass('active');
                        parent.removeClass('success');
                        parent.removeClass('error');
                    }
                    
                })
            
            })
        }

        //obtain file name for the file input
        $( '.hs-fieldtype-file .hs-input' ).each( function(){
            var $input	 = $( this ),
                $label	 = $input.parent().parent().find('label'),
                labelVal = $label.html();

            $input.on( 'change', function( e ){
                
                var fileName = '';

                if( this.files && this.files.length > 1 )
                    fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
                else if( e.target.value )
                    fileName = e.target.value.split( '\\' ).pop();

                if( fileName )
                    $label.find( 'span' ).html( fileName );
                else
                    $label.html( labelVal );
            });

            // Firefox bug fix
            $input
            .on( 'focus', function(){ $input.addClass( 'has-focus' ); })
            .on( 'blur', function(){ $input.removeClass( 'has-focus' ); });
        });
        
     });

});